export default "__VITE_ASSET__ChdYgjfX__"